import * as types from "./types";

export const fetchingCircleSuggestions = (collection, featured) => ({
  type: types.FETCHING_CIRCLE_SUGGESTIONS,
  collection: collection,
  featured: featured,
  loading: true
});

export const fetchedCircleSuggestions = (collection, suggestions, limit, offset, featured, has_more) => ({
  type: types.FETCHED_CIRCLE_SUGGESTIONS,
  collection: collection,
  suggestions: suggestions,
  loading: false,
  limit: limit,
  offset: offset,
  featured: featured,
  has_more: has_more
});

export const fetchedCircleSuggestion=(collection, suggestion, featured)=>({
  type: types.FETCHED_CIRCLE_SUGGESTION,
  collection: collection,
  suggestion: suggestion,
  loading: false,
  featured: featured
});

export const errorFetchingCircleSuggestions = (collection, error) => ({
  type: types.ERROR_FETCHING_CIRCLE_SUGGESTIONS,
  collection: collection,
  error: error,
  loading: false
});
